import type { ProctorSpecification } from "../../proctor/ProctorSpecification";
import type { ProctorAllocation } from "../types/JSTProctorBridge";
import { getTareBridge } from "./getTareBridge";

/**
 * This method is used to get a proctor allocation for a single test.
 *
 * @see JSTProctorBridge
 * @returns A promise that resolves to the proctor allocation for the test, or null if the API is unavailable
 */
export async function getProctorAllocation(
  test: ProctorSpecification,
): Promise<ProctorAllocation | null> {
  const tareBridge = getTareBridge();
  if (typeof tareBridge?.getProctorAllocation !== "function") {
    return null;
  }

  return tareBridge.getProctorAllocation(test.name);
}
